// Angular + external
import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { LoggerService } from "@bfx/logger";
import { AutoComplete } from "@bfx/primeng/autocomplete";
import { TranslateService } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  BfxBlotterNewFilterActionEvent,
  EXTENDED_TYPE_PROPERTY_NAME,
} from "../bfx-blotter-filter/bfx-blotter-filter.constants";
import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxDialogBaseComponent } from "./bfx-dialog-base.component";
import { BfxDialogData } from "./models/bfx-dialog-data.model";
const logger = LoggerService.for(__dirname);

import { AssetClass } from "shared/cubiq-model-multi-asset";
import { ExtendedOrderTypeIdentifier } from "../bfx-blotter-filter/models/bfx-blotter-filter.constants";
import { NativeDesktopSupport } from "../bfx-native-desktop/native-desktop-support";

@Component({
  selector: "bfx-dialog-filter-new",
  templateUrl: "./html/bfx-dialog-filter-new.html",
  standalone: false,
})
export class BfxDialogFilterNewComponent extends BfxDialogBaseComponent implements OnDestroy {
  @ViewChild("copyFilter_filterName_autoComplete", { static: true })
  private _copyFilter_filterName_autoComplete: AutoComplete;

  public filterNameValid: boolean = false;
  public filterNameEmpty: boolean = true;
  private blotterDefImpl: Array<CubiqTS.BlotterDefinitionImpl> = [];
  private newFilterCallback: any;
  private extendedTypeId: ExtendedOrderTypeIdentifier;

  /***************************************/
  /* DATA */
  public config: any = {
    debug: true,
  };

  public data = {
    dialogId: null,
    dialogEventSubject: new Subject<BfxDialogData>(),
    actionEvent: null,
    payload: null,
    dialogData: {
      show: false,
      width: 450,
      height: 150,
      title_text: "New Filter",
      message_text_invalid: "Filter Name Criteria Invalid",
      autocomplete_filterName: "",
    },
    blotterType: 0,
  };

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private _translationService: TranslateService,
    private _filterService: BfxBlotterFilterService,
    private _element: ElementRef,
  ) {
    super();
  }

  ngAfterViewInit() {}

  ngOnDestroy() {}

  public openDialog(dialogData: BfxDialogData): Observable<any> {
    this.blotterDefImpl = [];
    this.data.dialogId = dialogData.dialogId;
    this.data.blotterType = dialogData.payload.blotterType;
    this.extendedTypeId = dialogData.payload.extendedTypeId;
    let event: BfxBlotterNewFilterActionEvent = dialogData.event;
    this.data.actionEvent = event;
    this.newFilterCallback = this.data.actionEvent._callback;
    this.data.actionEvent._service.getAll().then((blotters: CubiqTS.BlotterDefinitionImpl[]) => {
      this.blotterDefImpl = blotters.filter(
        (f) => f.blotterType === this.data.blotterType && this.isolateBasedOnExtendedTypeId(f),
      );
    });

    this._filterService.setIsEditableMode(true);
    this._filterService.setIsDialogMode(true);

    NativeDesktopSupport.prepareEmbeddedDialog(dialogData.body, this._dialog, this._element);
    this.data.dialogData.show = true;

    return this.data.dialogEventSubject.asObservable();
  }

  public closeDialog(): void {
    super.closeDialog();

    this._filterService.setIsEditableMode(false);
    this._filterService.setIsDialogMode(false);
    this.data.dialogData.show = false;
    // inform dialog service that dialog is closed and to cleanup
    this.notifyDialogClosed(this.data.dialogEventSubject, this.data.dialogId);
  }

  /* COPY FILTER INTO- Actions */
  public actionCreateFilter_confirm(): void {
    if (this.filterNameValid) {
      this.newFilterCallback(this.data.dialogData.autocomplete_filterName);
      this._filterService.setEditMode(
        true,
        this.data.blotterType,
        AssetClass.FIX,
        this.extendedTypeId,
      );
      this.closeDialog();
    }
  }

  public actionCreateFilter_close(): void {
    this.closeDialog();
  }

  public helperCreateFilter_validateFilterName(event: any) {
    let data: string = event.query != null ? event.query : event;

    if (data != null && data.length == 0) {
      this.filterNameValid = false;
      this.filterNameEmpty = true;
      return;
    }
    if (data != null && data.length > 50) {
      this.filterNameValid = false;
      this.filterNameEmpty = false;
      this.data.dialogData.message_text_invalid =
        this._translationService.instant("filter.name.too.long");
      return;
    }
    if (
      this.blotterDefImpl.filter(
        (b) => b[this.data.actionEvent._field].toLowerCase() == data.toLowerCase(),
      ).length > 0
    ) {
      this.filterNameValid = false;
      this.filterNameEmpty = false;
      this.data.dialogData.message_text_invalid = this._translationService.instant(
        "blotter.already.exists",
        [data],
      );
      return;
    } else {
      this.filterNameValid = true;
      this.filterNameEmpty = false;
      this.data.dialogData.autocomplete_filterName = data;
    }
  }

  private isolateBasedOnExtendedTypeId(item: CubiqTS.BlotterDefinitionImpl): boolean {
    let isBmarkFilter = this.extendedTypeId === ExtendedOrderTypeIdentifier.BENCHMARK;
    if (this.data.blotterType === CubiqTS.BlotterType.ORDER) {
      let itemExtendedType = item.extendedInfo.get(EXTENDED_TYPE_PROPERTY_NAME);
      return itemExtendedType != null
        ? ExtendedOrderTypeIdentifier[itemExtendedType] ==
            ExtendedOrderTypeIdentifier[this.extendedTypeId]
        : !isBmarkFilter;
    }
    return true;
  }
}
